import React from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Tag,
  Progress,
  Grid,
} from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  SafetyCertificateOutlined,
  GlobalOutlined,
  MailOutlined,
  CloudOutlined,
  FolderOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import HeroImgs from "../../assets/images/HeroImgs.svg";
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export default function LandingHero() {
  const screens = useBreakpoint();

  return (
    <div
      style={{
        padding: screens.md ? "64px" : "24px",
        background: "#ffffff",
      }}
    >
      <Row
        align="middle"
        justify="center"
        style={{ maxWidth: 1400, margin: "0 auto", gap: screens.md ? 48 : 24 }}
      >
        {/* LEFT SECTION */}
        <Col xs={24} md={10} style={{ flex: 1 }}>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <Text strong style={{ color: "#2d1e6b" }}>
              Up to 75% off web hosting
            </Text>

            <Title level={1} style={{ margin: 0, color: "#2d1e6b" }}>
              Secure. Speedy. The Way <br /> Your Website Should Be
            </Title>

            <Space direction="vertical">
              <Text>
                <CheckCircleOutlined
                  style={{ color: "#52c41a" }}
                />{" "} 
                24/7 customer support
              </Text>
              <Text>
                <CheckCircleOutlined
                  style={{ color: "#52c41a" }}
                />{" "}
                Free Domain
              </Text>
              <Text>
                <CheckCircleOutlined
                  style={{ color: "#52c41a"}}
                />{" "}
                Free website migration
              </Text>
            </Space>

            <div>
              <Title level={2} style={{ marginBottom: 0, color: "#2d1e6b" }}>
                $2.99{" "}
                <Text
                  type="secondary"
                  style={{  color: "#2d1e6b" }}
                >
                  /mo
                </Text>
              </Title>
              <Text type="secondary" style={{ color: "#2d1e6b" }}>+3 months free</Text>
            </div>

            <Space wrap>
              <Button
                type="primary"
                size="large"
                style={{ background: "#6d28d9" }}
              >
                Claim deal
              </Button>
              <Tag icon={<ClockCircleOutlined />} color="purple">
                01 : 19 : 51 : 31
              </Tag>
            </Space>

            <Text type="secondary" style={{ color: "#2d1e6b" }}>
              30-Day Money-Back Guarantee
            </Text>
          </Space>
        </Col>

        {/* RIGHT SECTION */}
        <Col xs={24} md={14} style={{ flex: 1 }}>
          <Card
            style={{
              borderRadius: 16,
              background: "#f6f7ff",
              position: "relative",
            }}
          >
            {/* TOP BADGES */}
            <Space style={{ marginBottom: 16 }}>
              <img
                src={HeroImgs}
                alt="logo"
              />
              <Tag icon={<SafetyCertificateOutlined />} color="green">
                SSL certificate · ACTIVE
              </Tag>
            </Space>

            {/* PERFORMANCE CARD */}
            <Card
              style={{
                position: screens.md ? "absolute" : "static",
                right: screens.md ? -20 : 0,
                top: screens.md ? -20 : 0,
                borderRadius: 12,
                marginBottom: screens.md ? 0 : 24,
              }}
            >
              <Text strong>Performance score for mynewpage.online</Text>
              <Space align="center" style={{ marginTop: 12 }}>
                <Progress type="circle" percent={99} width={70} />
                <Space direction="vertical">
                  <Text>
                    <span style={{ color: "#ff4d4f" }}>●</span> 0–49
                  </Text>
                  <Text>
                    <span style={{ color: "#faad14" }}>●</span> 50–89
                  </Text>
                  <Text>
                    <span style={{ color: "#52c41a" }}>●</span> 90–100
                  </Text>
                </Space>
              </Space>
            </Card>

            {/* MANAGEMENT PANEL */}
            <Title level={4}>Management Panel</Title>

            <Card style={{ borderRadius: 12, marginBottom: 24 }}>
              <Row gutter={[24, 24]}>
                <Col xs={24} md={6}>
                  <Space direction="vertical">
                    <Space>
                      <GlobalOutlined />
                      <Text strong>Business</Text>
                    </Space>
                    <Text type="secondary">Active</Text>
                    <Button type="link">See details</Button>
                  </Space>
                </Col>

                <Col xs={24} md={6}>
                  <Space direction="vertical">
                    <Space>
                      <GlobalOutlined />
                      <Text strong>Domain</Text>
                    </Space>
                    <Text type="secondary">Active</Text>
                    <Button type="link">Manage</Button>
                  </Space>
                </Col>

                <Col xs={24} md={6}>
                  <Space direction="vertical">
                    <Space>
                      <MailOutlined />
                      <Text strong>Business Email</Text>
                    </Space>
                    <Text type="secondary">Active</Text>
                    <Button type="link">Manage</Button>
                  </Space>
                </Col>

                <Col xs={24} md={6}>
                  <Space direction="vertical">
                    <Space>
                      <CloudOutlined />
                      <Text strong>Daily backups</Text>
                    </Space>
                    <Text type="secondary">Enabled</Text>
                    <Button type="link">Manage</Button>
                  </Space>
                </Col>
              </Row>
            </Card>

            {/* ACTION BUTTONS */}
            <Row gutter={16} style={{ marginBottom: 24 }}>
              <Col xs={24} md={8}>
                <Button block icon={<FolderOutlined />}>
                  File manager
                </Button>
              </Col>
              <Col xs={24} md={8}>
                <Button block icon={<DatabaseOutlined />}>
                  Databases
                </Button>
              </Col>
              <Col xs={24} md={8}>
                <Button block icon={<GlobalOutlined />}>
                  WordPress overview
                </Button>
              </Col>
            </Row>

            {/* BOTTOM INFO */}
            <Row gutter={[24, 24]}>
              <Col xs={24} md={12}>
                <Card>
                  <Space>
                    <CheckCircleOutlined
                      style={{ fontSize: 22, color: "#52c41a" }}
                    />
                    <Space direction="vertical">
                      <Text strong>Safe</Text>
                      <Text type="secondary">No malware found</Text>
                      <Button type="link">See malware scanner</Button>
                    </Space>
                  </Space>
                </Card>
              </Col>

              <Col xs={24} md={12}>
                <Card>
                  <Space>
                    <img
                      src="https://via.placeholder.com/48"
                      alt="avatar"
                      style={{ borderRadius: "50%" }}
                    />
                    <Text>
                      Your website <strong>migration</strong> has been{" "}
                      <strong>completed</strong>{" "}
                      <CheckCircleOutlined style={{ color: "#52c41a" }} />
                    </Text>
                  </Space>
                </Card>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
